<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconPlay_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M21.13 13.498 8.317 20.812c-1.152.657-2.582-.174-2.582-1.498V4.686c0-1.324 1.43-2.155 2.58-1.498l12.814 7.314c1.162.662 1.162 2.334.003 2.996Z"
    />
</svg>
